function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.5 10.25a.25.25 0 01-.25.25h-2.5a.25.25 0 010-.5h2.5a.25.25 0 01.25.25zm1.25-4a2.736 2.736 0 01-1.051 2.163.507.507 0 00-.199.4V9a.5.5 0 01-.5.5H6a.5.5 0 01-.5-.5v-.187a.5.5 0 00-.195-.396A2.737 2.737 0 014.25 6.265 2.764 2.764 0 016.934 3.5 2.75 2.75 0 019.75 6.25zm-.5 0A2.25 2.25 0 006.946 4 2.26 2.26 0 004.75 6.262a2.24 2.24 0 00.864 1.76 1 1 0 01.386.79V9h2v-.187a1.005 1.005 0 01.39-.793 2.239 2.239 0 00.86-1.77zm-.503-.292a1.8 1.8 0 00-1.455-1.455.25.25 0 00-.084.494 1.31 1.31 0 011.045 1.045.25.25 0 00.494-.084z",
  fill: "#979797"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "7",
  cy: "7",
  r: "6.65",
  stroke: "#979797",
  strokeWidth: ".7"
})));